import styles from './Experiences.module.css';

import posts from '../../json/posts.json';
import PostCard from "../../components/PostCard";
import PostModel from '../../components/PostModel';
import fotoCapa from "../../assets/about_me_head.png";

export default function Experiences() {
    return (
        <PostModel
        fotoCapa={fotoCapa}
        title="Experiência"
        >
            <ul className={styles.posts}>
                    {posts.map((post) => (
                        <li key={post.id}>
                            <PostCard post={post} />
                        </li>
                    ))}
                </ul>
        </PostModel>
    )
}